/**
 * useCreateInsight Hook
 * Mutation for creating new insights with cache invalidation
 */

import { useMutation, useQueryClient } from '@tanstack/react-query'
import { insightsRepo } from '@/lib/repositories'
import type { CreateInsightData } from '@/lib/repositories/interfaces/IInsightsRepository'
import { INSIGHTS_QUERY_KEY } from './useInsights'
import { analytics } from '@/lib/services/analytics'
import { AnalyticsEvents } from '@/lib/services/analytics-events'

export function useCreateInsight() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: CreateInsightData) => insightsRepo.createInsight(data),
    onSuccess: (_, data) => {
      // Invalidate insights query to refetch
      // Note: Realtime will also push the update, but this ensures immediate UI update
      queryClient.invalidateQueries({ queryKey: INSIGHTS_QUERY_KEY })
      analytics.capture(AnalyticsEvents.INSIGHT_CREATED, {
        sentiment: data.sentiment,
        has_ticker: !!data.ticker,
        ticker: data.ticker,
      })
    },
  })
}
